const getIconName = (fileName: string): string => {
  const fileExtension = fileName.split('.').slice(-1)[0];
  switch (fileExtension) {
    case 'doc':
    case 'docx': {
      return 'WordLogo';
    }

    case 'pdf': {
      return 'PDF';
    }

    case 'xls':
    case 'xlsx': {
      return 'ExcelLogo';
    }

    case 'ppt':
    case 'pptx': {
      return 'PowerPointLogo';
    }

    case 'msg': {
      return 'OutlookLogo';
    }

    case 'jpg':
    case 'jpeg':
    case 'png': {
      return 'FileImage';
    }

    case 'txt': {
      return 'TextDocument';
    }

    default:
      return 'OpenFile';
  }
};

export default getIconName;
